import { render, staticRenderFns } from "./TravelsReport.vue?vue&type=template&id=37495ed2&scoped=true"
import script from "./TravelsReport.vue?vue&type=script&lang=ts"
export * from "./TravelsReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37495ed2",
  null
  
)

export default component.exports